<div *ngIf="selectedChartType === 'line'" class="form-group input-group has-feedback" style="margin-bottom: 15px; position: relative;">
    <label class="control-group input-group-addon">Increments
        <button class="info-btn"
                type="button"
                [attr.title]="info('increments')"
                (click)="onInfoClick($event, 'increments')">
            i
        </button>
    </label>
    <input type="text"
           class="form-control"
           style="padding-left: 15px"
           [value]="getIncrementLabel(selectedTimePeriod)"
           readonly
           tabindex="-1"
           (click)="hideTooltip()" />

    <div class="click-tooltip"
         *ngIf="isTooltipVisible('increments')"
         (click)="hideTooltip()">
        {{ info('increments') }}
    </div>
</div>
